"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownCircleOutline = _interopRequireDefault(require("./IconChevronDownCircleOutline"));
var IconChevronUpCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownCircleOutline.default).withConfig({
  displayName: "IconChevronUpCircleOutline",
  componentId: "c11n-8-107-0__sc-152l1fo-0"
})(["transform:rotate(180deg);"]);
var _default = IconChevronUpCircleOutline;
exports.default = _default;